import { REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import { REDUCER_KEY_PROJECT_ROUTES } from '@Pages/RetroSynthesis/ProjectRoutes/constants';

const getRsState = (state) =>
  state && state.get && state.get(REDUCER_KEY_RS);

const getProjectsRoutesData = (state) =>
  getRsState(state).get(REDUCER_KEY_PROJECT_ROUTES);

const getProjectsRoutesDataResponse = (state) =>
  getProjectsRoutesData(state).response || {};

export const getProjectsRoutesDataResponseList = (state) =>
  getProjectsRoutesDataResponse(state).content || [];

export const getProjectsRoutesDataResponseListCount = (state) =>
  getProjectsRoutesDataResponse(state).totalElements || 0;

export const getRoutesTreeTooltip = (state) =>
  getProjectsRoutesData(state).treeTooltip || { data: null, target: null };
